import { TResApi, TResApiErr, TResDataListApi } from '@src/configs/interface.config'
import { checkAuth } from '@src/libs/localStorage'
import { useMutation, useQuery } from 'react-query'
import { notification } from 'antd'
import { NError, NSuccess } from '@src/configs/const.config'
import { TQuerySpecialDealUser, TSpecialDealUser } from '@src/modules/special-deal-user'
import {
  changeSpecialDealUserById,
  getLisSpecialDealUser,
  removeManySpecialDealUserByIds,
  removeSpecialDealUserById,
} from '@queries/apis'
import { DETAIL_SPECIAL_DEAL_USER, LIST_SPECIAL_DEAL_USER } from '@queries/keys'

import { queryClient } from '..'

export const useQueryListSpecialDealUser = (params: TQuerySpecialDealUser, token?: string) => {
  const accessToken = token || checkAuth()
  return useQuery<TResDataListApi<TSpecialDealUser[]>>(
    [LIST_SPECIAL_DEAL_USER, JSON.stringify(params)],
    () => getLisSpecialDealUser(params, accessToken),
    {
      enabled: !!accessToken,
    },
  )
}

export const useMutationRemoveSpecialDealUserById = () =>
  useMutation(removeSpecialDealUserById, {
    onSuccess: (res: TResApi, id) => {
      queryClient.refetchQueries([LIST_SPECIAL_DEAL_USER]).then()
      queryClient.removeQueries([DETAIL_SPECIAL_DEAL_USER, id])
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      // [TODO] ...
      notification.error({ message: NError, description: error?.message })
    },
  })

export const useMutationUpdateStatusSpecialDealUser = () => {
  const token = checkAuth()
  return useMutation((data: any) => changeSpecialDealUserById(data, token), {
    onSuccess: (res: TResApi<TSpecialDealUser>) => {
      queryClient.refetchQueries([LIST_SPECIAL_DEAL_USER]).then()
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      // [TODO] ...
      notification.error({ message: NError, description: error?.message })
    },
  })
}

export const useMutationRemoveManySpecialDealUserByIds = () =>
  useMutation(removeManySpecialDealUserByIds, {
    onSuccess(res: TResApi<boolean>, ids) {
      queryClient.refetchQueries([LIST_SPECIAL_DEAL_USER]).then()
      if (res.data) {
        ids.forEach((id) => {
          queryClient.removeQueries([DETAIL_SPECIAL_DEAL_USER, id])
        })
      }
      notification.success({ message: NSuccess, description: res?.message })
    },
  })
